    <template>
    <div class="pro_index">
        <el-container>
            <el-aside style="width: 200px">
                <ul class="left_url_tab">
                    <li class="li-title li_menu" id="menu_1">
                        <span class="m-left10"><b>采集箱</b></span>
                    </li>
                    <li class="li-title li_active">
                        <span class="m-left10"><router-link class="r_link" to="/coll">「Lazada」采集箱 (210)</router-link></span>
                    </li>
                    <li class="li-title li_menu">
                        <span class="m-left10"><b>待发布产品</b></span>
                        <a class="a-set blueCo" href="javascript:void(0)" @click="setClassManage">设置</a>
                    </li>
                    <li class="li_border"></li>
                    <li class="li-msg li_border"><router-link class="r_link" to="/timeInterval">定时发布 (0)</router-link></li>
                    <li class="li-msg li_border">发布中 (0)</li>
                    <li class="li-msg li_border">发布失败 (35)</li>
                    <li class="li-title li_menu">
                        <span class="m-left10"><b>在线产品</b></span>
                        <a class="a-set blueCo" href="javascript:void(0)">设置</a>
                    </li>
                    <li class="li_border"></li>
                    <li class="li-msg blueCo"><a class="blueCo" href="http://help.dianxiaomi.com/help/index.htm" target="_blank">帮助手册</a></li>
                </ul>
            </el-aside>
            <el-main>

            </el-main>
        </el-container>
        <ClassManage @closeCMDialog_z="closeCMDialog_f" :classManageDialog="classManageDialog"></ClassManage>
    </div>
</template>

<script>

    export default {
        name: "dataCollection",
        components:{
            ClassManage
        },
        data() {
            return {
                classManageDialog:false,//管理分类弹窗默认关闭
            }
        },
        created() {

        },
        methods: {
            setClassManage:function(){
                this.classManageDialog = true;
            },
            closeCMDialog_f:function(){
                this.classManageDialog = false;
            },
        },
        mounted() {}
    }
</script>

<style scoped>
    @import '../../../assets/css/Lazada.css';
    .pro_index{
        width: 100%;
    }
</style>
